import Tabs from './Tabs';

export default Tabs;
export * from './Tabs';
